export default __webpack_public_path__ + "static/media/service-prototypes.69e82df9.svg";